
import { LoaderCircle } from "lucide-react";

export function FullScreenLoader() {
  return (
    <div className="fixed inset-0 z-50 bg-background/80 flex flex-col items-center justify-center">
      <img 
        src="/lovable-uploads/c075a6f2-9d57-4c52-9766-e3aa7a5b1c7d.png"
        alt="App Logo"
        className="w-28 h-auto mb-8 opacity-95 animate-bounce"
      />
      <div className="flex flex-col items-center gap-3">
        <LoaderCircle className="w-12 h-12 text-primary animate-spin" aria-label="Loading" />
        <span className="text-lg text-muted-foreground font-semibold animate-pulse">Loading...</span>
      </div>
    </div>
  );
}
